import { successAction, GET_EVENT, CLEAN_EVENT } from '../types';

const initialState = {
  event: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CLEAN_EVENT:
    case successAction(GET_EVENT): {
      return {
        ...state,
        event: action.payload,
      };
    }

    default:
      return state;
  }
};
